import { useContext, useFetch, provide, ssrRef, inject } from '@nuxtjs/composition-api';
import { IS_PROD, IS_DEV, IS_STAGING, LANG } from '../../constants/config';
export const installMetadataConfig = () => {
  const config = ssrRef(null, 'config');
  provide('config', config);
  const { $service } = useContext();
  useFetch(async () => {
    const { data } = await $service.config.getMetadataConfig();
    config.value = data;
  });
};

export const useMetadataConfig = () => {
  const config = inject('config');
  return config.value;
};

export const getRedisKeyPrefix = () => {
  let envKey = '';
  if (IS_PROD) envKey = 'PROD';
  else if (IS_DEV) envKey = 'DEV';
  else if (IS_STAGING) envKey = 'STAG';
  return `${envKey}:${LANG.toUpperCase()}`;
};
